import { titleAndTypeObjProps } from "../_type";

export const titleAndTypeObj: titleAndTypeObjProps = {
  mau: 'MAU',
  wau: 'WAU',
  dau: 'DAU',
  mtx_revenue: 'Mtx Revenue',
  new: 'New',
  units: 'full game units',
  revenue: 'platform net revenue',
  inflexion_new_churn: 'New Churn',
  mtx_revenue_v4: 'Revenue V4',
  wow_cnt_role: 'DAU',
  wow_player_act_num: 'Player Dau',
  wow_player_new_num: 'Player New',
  wow_player_inv_num: 'Player Return',
  wow_author_act_num: 'Creator Dau',
  wow_author_new_num: 'Creator New',
  wow_author_inv_num: 'Creator Return',
  gross_full_game_units: 'Gross Base Game Units',
  gross_revenue: 'Gross Revenue',
};

export const shareAndTypeObj: titleAndTypeObjProps = {
  inflexion_new_churn: 'Share'
};

export const dauMetricsArr =
  [
    'dau',
    'wau',
    'mau',
    "wow_cnt_role",
    "wow_player_act_num",
    "wow_player_new_num",
    "wow_player_inv_num",
    "wow_author_act_num",
    "wow_author_new_num",
    "wow_author_inv_num"
  ];

// 常见的格式化规则映射（参考 mapFormatRuleToType）,用于兼容排行榜浮窗的旧逻辑,代码中还会有模糊匹配
export const formatRuleToTypeMap: Record<string, 'int' | 'decimals' | 'percent'> = {
  'int': 'int',
  'oneDecimal': 'decimals',
  'twoDecimal': 'decimals',
  'percent1Decimal': 'percent',
  'percent2Decimal': 'percent',
  'percentInt': 'percent',
  'percentDecimal': 'percent',
  'thousandsInit': 'int',
  'thousands1Decimal': 'decimals',
  'thousands2Decimal': 'decimals',
  'bmk': 'int',
  'bmk0': 'int',
  'bmk00': 'int',
};
